export enum TaskPriorityEnumValues {
  Low = "Low",
  Medium = "Medium",
  High = "High"
}
